import { render, staticRenderFns } from "./CountryRow.vue?vue&type=template&id=21918919&"
import script from "./CountryRow.vue?vue&type=script&lang=js&"
export * from "./CountryRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports